module.exports = __webpack_public_path__ + "img/13_38.39772b4d.png";